// extracted by mini-css-extract-plugin
export default {"project-loader-wrapper":"FilesPageProjectLoader_project-loader-wrapper__YF0z4"};